import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, Checkbox, FormControlLabel } from '@mui/material';

interface LabeledCheckboxProps {
    label: string;
    checked: boolean;
    onChange: any;
}

function LabeledCheckboxComponent({ label, checked, onChange}: LabeledCheckboxProps) {
    return (<FormControlLabel
        sx={{ m: 0 }}
        label={label}
        control={
            <Checkbox
                checked={checked}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    onChange(e);
                }}
            />
        }
    />);
}

export default LabeledCheckboxComponent;